import { render, staticRenderFns } from "./BackgroundVideo.vue?vue&type=template&id=372ca653&scoped=true&"
import script from "./BackgroundVideo.vue?vue&type=script&lang=js&"
export * from "./BackgroundVideo.vue?vue&type=script&lang=js&"
import style0 from "./BackgroundVideo.vue?vue&type=style&index=0&id=372ca653&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "372ca653",
  null
  
)

export default component.exports